import { makeStyles } from "@material-ui/core";

export default makeStyles(
  (theme) => ({
    playerWrapper: {
      position: "relative",
      paddingTop: "56.25%",
    },
    player: {
      position: "absolute",
      top: 0,
      left: 0,
      "& video": {
        objectFit: "cover",
      },
    },
    overlay: {
      background: "linear-gradient(180deg,rgba(0,0,0,0) 0,#000 100%)",
      width: "100%",
      height: "50%",
      position: "absolute",
      bottom: 0,
      left: 0,
      opacity: 0.5,
      pointerEvents: "none",
    },
    imageName: {
      position: "absolute",
      left: 10,
      bottom: 0,
      width: "auto",
      height: "35%",
      pointerEvents: "none",
    },
    duration: {
      position: "absolute",
      fontSize: 12,
      color: "#fff",
      right: 10,
      bottom: 10,
      pointerEvents: "none",
      [theme.breakpoints.up("mobile")]: {
        right: 20,
        bottom: 15,
      },
      [theme.breakpoints.up("tablet")]: {
        right: 40,
        bottom: 30,
        fontSize: 18,
      },
    },
  }),
  { name: "StarringYouClip" },
);
